var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:education"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.25 16.9363L12 19.8895L6.75 16.9363V13.8163L5.25 12.9829V17.8136L12 21.6104L18.75 17.8136V12.9829L17.25 13.8163V16.9363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 2.65503L1.5 8.09947V9.3995L12 15.2327L21 10.2328V14.3749H22.5V8.09947L12 2.65503ZM19.5 9.35023L18 10.1835L12 13.517L6 10.1835L4.5 9.35023L3.46036 8.77264L12 4.34469L20.5396 8.77264L19.5 9.35023Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation2);
export default __webpack_public_path__ + "static/media/education2.9109cf855bc594e746e16710a8ecfcb5.svg";
export { ForwardRef as ReactComponent };